import { render, staticRenderFns } from "./RatingCard.vue?vue&type=template&id=7a8836ce&scoped=true&"
import script from "./RatingCard.vue?vue&type=script&lang=js&"
export * from "./RatingCard.vue?vue&type=script&lang=js&"
import style0 from "./RatingCard.vue?vue&type=style&index=0&id=7a8836ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8836ce",
  null
  
)

export default component.exports